module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external "cadesplugin-api/dist/cadesplugin_api.js"
// module id = 12
// module chunks = 0